import React from 'react'

const Disclaimer = () => {
    return (
        <div>
            <h1>Disclaimer:</h1>
            <p>Pls don't blame us if anything wrong happens.</p>
        </div>
    )
}

export default Disclaimer